import React from "react";
import FollowingMap from "./Content/FollowingMap";

const FollowMain = () => {
  return (
    <>
      <FollowingMap />
    </>
  );
};

export default FollowMain;
